import { ScorePoint } from "components/simple/ScoreHistoryChart";

/**
 * Maps the backend pulseScoreHistory response shape into the ScorePoint[]
 * interface expected by ScoreHistoryChart.
 *
 * The backend returns `calculatedAt` as an ISO 8601 string in descending order
 * (most recent first), but ScoreHistoryChart expects ISO date strings in
 * chronological (ascending) order for proper timeline display.
 */
export function mapScoreHistory(
  history: Array<{ pulseIndex: number; calculatedAt: string }>
): ScorePoint[] {
  return [...history]
    .sort(
      (a, b) =>
        new Date(a.calculatedAt).getTime() - new Date(b.calculatedAt).getTime()
    )
    .map(s => ({
      scoredAt: s.calculatedAt,
      score: s.pulseIndex
    }));
}
